import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "215ffc80-924a-4cdd-93a9-dcddbe3e9865",
  solutionType: "text-or-number",
  type: "fillTheGap",
  options: {
    type: "text",
    prefixText: "Input <b>frequency range</b> (example: 200-4000):",
    suffixText: "Hz",
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: "30-20000",
};
